import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

const TOKENS = {
  panel: "rgba(255,255,255,0.9)",
  radius: 8,
  dotIdle: "#8D8D8D",
  dotActive: "#E5007E",
  border: "#E9E9E9",
};

export default function DotsStrip({
  count = 2,
  cur = 0,
  maxDots = 6,
  sx,
}) {
  // number of visible dots
  const visible = Math.min(count, maxDots);
  const dots = Array.from({ length: visible });

  return (
    <Box
      sx={{
        width: { xs: 20, md: 25, lg: 30 },
        height: { xs: 80, md: 120 },
        minHeight: 66,
        maxHeight: 220,
        bgcolor: TOKENS.panel,
        borderRadius: TOKENS.radius,
        border: `1px solid ${TOKENS.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        ...sx,
      }}
    >
      <Stack
        spacing={1}
        alignItems="center"
        sx={{
          maxHeight: "100%",
          overflowY: "auto",
          py: 1,
          justifyContent: "center",
        }}
      >
        {dots.map((_, i) => {
          const isActive = i === cur;
          return (
            <Box
              key={i}
              role="button"
              aria-label={`Εικόνα ${i + 1}`}
              tabIndex={0}
              sx={{
                width: { xs: "8px", md: "10px" },
                height: { xs: "8px", md: "10px" },
                minWidth: { xs: "8px", md: "10px" },
                minHeight: { xs: "8px", md: "10px" },
                borderRadius: "50%",
                bgcolor: isActive ? TOKENS.dotActive : TOKENS.dotIdle,
                flexShrink: 0,
                cursor: "pointer",
              }}
            />
          );
        })}
      </Stack>
    </Box>
  );
}
